import React from 'react'
import { Modal } from 'antd'
import CreateTextAssignmentForm from './CreateTextAssignmentForm'
import { useDispatch } from 'react-redux'
import { toggleCreateTextAssignmentModal } from '../../../../../../../store/slices/assignment.slice'

const CreateTextAssignmentModal = () => {
    const dispatch = useDispatch()

    return (
        <Modal
            title='Create Text Assignment'
            open={true}
            footer={null}
            onCancel={() => dispatch(toggleCreateTextAssignmentModal())}
        >
            <CreateTextAssignmentForm />
        </Modal>
    )
}

export default CreateTextAssignmentModal
